<template>
  <div class="yhc-component YhcDateTimePicker" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-date-picker
        time-arrow-control
        class="el-component-item"
        :editable="false"
        :clearable="true"
        type="datetime"
        v-model="result"
        @change="$_change"
        :placeholder="placeholder"
      ></el-date-picker>
    </div>

    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import methodsMixin2 from './componentsData/methodsMixin2';
import watchMixin2 from './componentsData/watchMixin2';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

let identifierName = 'YhcDateTimePicker';
export default {
  name: identifierName,

  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin, methodsMixin, methodsMixin2, watchMixin2],

  data() {
    return {
      result: this.value,
    };
  },
  props: {
    value: {
      type: [String, Boolean, Number, Date],
    },
  },
  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcDateTimePicker {
  @include labelCommon();
}
</style>
